import { useEffect, useState } from "react";
import {
  BlueDot,
  GreenDot,
  OrangeDot,
  RedDot,
  YellowDot,
} from "../assets/images/svg/svg";
import {
  setEntityType,
  setOrgId,
  setOrganizationType,
} from "../slices/common/reducer";
// import Skeleton from "../Components/Common/Skeletons/Skeleton";
import rootReducer from "../store";
import dateFormat from "dateformat";
import { useSelector } from "react-redux";
import reducer from "../slices/layouts/reducer";

export const customSelectStyles = {
  control: (provided) => ({
    ...provided,
    fontSize: "14px",
    minHeight: "40px",
    width: "120px",
    borderRadius: "4px",
    boxShadow: "none",
    borderColor: "#026AFA",
    backgroundColor: "#026AFA",
    zIndex: 2000,
    "&:hover": {
      border: "1px solid #026AFA",
    },
    "&:focus": {
      border: "1px solid #026AFA",
    },
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999, // Adjust the z-index as needed
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: "#FFFFFF",
    "&:hover": {
      color: "#FFFFFF",
    },
    "&:focus": {
      color: "#FFFFFF",
    },
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#FFFFFF",
    fontSize: "12px",
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#FFFFFF",
  }),
  option: (provided, state) => ({
    ...provided,
    color: state.isSelected ? "#FFFFFF" : "#000000",
    backgroundColor: state.isSelected ? "#026AFA" : "#FFFFFF",
    "&:hover": {
      backgroundColor: "#adb5bd",
      color: "#FFFFFF",
    },
  }),
};

export const customSelect = {
  control: (provided) => ({
    ...provided,
    fontSize: "14px",
    minHeight: "40px",
    borderRadius: "4px",
    boxShadow: "none",
    width: "100%",
    // borderColor: "#026AFA",
    // backgroundColor: "#026AFA",
    zIndex: 2000,
    "&:hover": {
      // border: "1px solid #026AFA",
    },
    "&:focus": {
      // border: "1px solid #026AFA",
    },
  }),
  menuPortal: (base) => ({
    ...base,
    zIndex: 9999, // Adjust the z-index as needed
  }),

  indicatorSeparator: () => ({
    display: "none",
  }),
};

export const moduleCustomSelect = {
  control: (baseStyles) => ({
    ...baseStyles,
    borderColor: "#C7222A",
    "&:hover": { borderColor: "#C7222A" },
    "&:focus": { borderColor: "#C7222A" },
  }),

  theme: (theme) => ({
    ...theme,
    borderRadius: 0,
    colors: {
      ...theme.colors,
      primary: "#C7222A",
    },
  }),
};

export const renderLength = (type, length) => {
  switch (type) {
    case "active":
      return (
        <div
          className="activeLength"
          title={
            length > 100000
              ? formatAmount(length, "decimal", "removeFloat")
              : undefined
          }
        >
          {formatAmount(length, "decimal", "removeFloat", "lakh")}
        </div>
      );
    case "inactive":
      return (
        <div
          className="inActiveLength"
          title={
            length > 100000
              ? formatAmount(length, "decimal", "removeFloat")
              : undefined
          }
        >
          {formatAmount(length, "decimal", "removeFloat", "lakh")}
        </div>
      );
    default:
      break;
  }
};

export const renderStatus = (status) => {
  switch (status) {
    case "ACTIVE":
      return (
        // <div>
        //   <GreenDot />
        //   &nbsp;&nbsp;Active
        // </div>
        <span className="payment-success">ACTIVE</span>
      );
    case "INACTIVE":
      return (
        // <div>
        //   <RedDot />
        //   &nbsp;&nbsp;Inactive
        // </div>
        <span className="payment-pending">INACTIVE</span>
      );
    case "LINKED":
      return (
        // <div>
        //   <GreenDot />
        //   &nbsp;&nbsp;Active
        // </div>
        <span className="badge bg-success-subtle text-success text-uppercase fs-12">
          Linked
        </span>
      );
    case "UNLINKED":
      return (
        // <div>
        //   <RedDot />
        //   &nbsp;&nbsp;Inactive
        // </div>
        <span className="badge bg-light-subtle text-light text-uppercase fs-12">
          Unlinked
        </span>
      );
    case "ISSUED":
      return (
        // <div>
        //   <GreenDot />
        //   &nbsp;&nbsp;Active
        // </div>
        <span className="badge bg-success-subtle text-success text-uppercase fs-12">
          Issued
        </span>
      );
    case "Success":
      return (
        // <div>
        //   <GreenDot />
        //   &nbsp;&nbsp;Active
        // </div>
        <span className="badge bg-success-subtle text-success text-uppercase fs-12">
          Success
        </span>
      );
    case "Pending":
      return (
        // <div>
        //   <GreenDot />
        //   &nbsp;&nbsp;Active
        // </div>
        <span className="badge bg-warning-subtle text-warning text-uppercase fs-12">
          Pending
        </span>
      );
    case "Failed":
      return (
        <span className="payment-failed badge bg-error-subtle text-error text-uppercase fs-12">
          Failed
        </span>
      );
    case "PAYMENT_SUCCESS":
      return <span className="payment-success">PAYMENT SUCCESS</span>;

    case "PAYMENT_PENDING":
      return <span className="payment-pending">PAYMENT PENDING</span>;
    case "PAYMENT_FAILED":
      return <span className="payment-failed">PAYMENT FAILED</span>;

    case "PROPOSAL_PENDING":
      return <span className="proposal-pending">PROPOSAL PENDING</span>;

    case "CANCELLED":
      return <span className="cancelled">CANCELLED</span>;

    case "COMPLETED":
      return (
        <span className="badge bg-success-subtle text-warning text-uppercase fs-12">
          Completed
        </span>
      );
    case "AWAITED_UNDERWRITING":
      return (
        <span className="badge bg-warning-subtle text-warning text-uppercase fs-12">
          AWAITED UNDERWRITING
        </span>
      );
    case "DETAILS_AWAITED":
      return (
        <span className="badge bg-warning-subtle text-error text-uppercase fs-12">
          DETAILS AWAITED
        </span>
      );
    case "REJECTED":
      return (
        <span className="badge bg-error-subtle text-error text-uppercase fs-12">
          DETAILS AWAITED
        </span>
      );
    case "ISSUED":
      return (
        <span className="badge bg-success-subtle text-success text-uppercase fs-12">
          ISSUED
        </span>
      );

    default:
      return <div>{status}</div>;
  }
};

export const renderCommonStatus = (status) => {
  switch (status) {
    case "ACTIVE":
      return (
        <span className="badge green">
          <GreenDot />
          &nbsp;&nbsp;Active
        </span>
      );
    case "INACTIVE":
      return (
        <span className="badge red">
          <RedDot />
          &nbsp;&nbsp;Inactive
        </span>
      );
    case "SUCCESS":
      return (
        <span className="badge green">
          <GreenDot />
          &nbsp;&nbsp;Success
        </span>
      );
    case "PENDING":
      return (
        <span className="badge yellow">
          <YellowDot />
          &nbsp;&nbsp;Pending
        </span>
      );
    case "FAILED":
      return (
        <span className="badge red">
          <RedDot />
          &nbsp;&nbsp;Failed
        </span>
      );
    case "FAILURE":
      return (
        <span className="badge red">
          <RedDot />
          &nbsp;&nbsp;Failure
        </span>
      );
    case "MAKER":
      return (
        <span className="badge green">
          <BlueDot />
          &nbsp;&nbsp;Maker
        </span>
      );
    case "SETTLED":
      return (
        <span className="badge green">
          <GreenDot />
          &nbsp;&nbsp;Settled
        </span>
      );
    case "MATCHED":
      return (
        <span className="badge green">
          <GreenDot />
          &nbsp;&nbsp;Matched
        </span>
      );
    case "UNMATCHED":
      return (
        <span className="badge red">
          <RedDot />
          &nbsp;&nbsp;Unmatched
        </span>
      );
    case "FULLREFUND":
      return (
        <span className="badge green">
          <GreenDot />
          &nbsp;&nbsp;Full Refund
        </span>
      );
    case "PARTIALREFUND":
      return (
        <span className="badge green">
          <GreenDot />
          &nbsp;&nbsp;Partial Refund
        </span>
      );
    case "FILERECEIVED":
      return (
        <span className="badge yellow">
          <YellowDot />
          &nbsp;&nbsp;File Received
        </span>
      );
    case "FILEGENERATED":
      return (
        <span className="badge orange">
          <OrangeDot />
          &nbsp;&nbsp;File Generated
        </span>
      );
    case "UNSETTLED":
      return (
        <span className="badge red">
          <RedDot />
          &nbsp;&nbsp;Unsettled
        </span>
      );
    case "REFUND_INITIATED":
      return (
        <div className="badge blue">
          <BlueDot />
          &nbsp;&nbsp;Refund Initiated
        </div>
      );
    case "REFUNDED":
      return (
        <div className="badge green">
          <GreenDot />
          &nbsp;&nbsp;Refunded
        </div>
      );
    default:
      return <span>{status}</span>;
  }
};

export const renderDrillStatus = (status) => {
  switch (status) {
    case "MAKER":
      return <span className="drill-status blue">Maker</span>;
    case "FILEGENERATED":
      return <span className="drill-status blue">File Generated</span>;
    case "SETTLED":
      return <span className="drill-status green">Settled</span>;
    case "ACTIVE":
      return <span className="drill-status green">Active</span>;
    case "PENDING":
      return <span className="drill-status orange">Pending</span>;
    default:
      return <span>{status}</span>;
  }
};

export const renderCustomTabStatus = (status) => {
  switch (status) {
    case "N":
      return <span>New</span>;
    case "I":
      return <span>Initiated</span>;
    case "C":
      return <span>Completed</span>;
    case "A":
      return <span>Approved</span>;
    case "P":
      return <span>Pending</span>;
    case "V":
      return <span>void</span>;
    case "R":
      return <span>Rejected</span>;
    case "E":
      return <span>Expired</span>;
    case "Ap":
      return <span>Approve&nbsp;Pending</span>;
    case "AP":
      return <span>Approve&nbsp;Pending</span>;
    case "Af":
      return <span>Approve&nbsp;Failed</span>;
    case "AF":
      return <span>Approve&nbsp;Failed</span>;
    case "Rf":
      return <span>Reject&nbsp;Failed</span>;
    case "RF":
      return <span>Reject&nbsp;Failed</span>;
    case "Refund_initiated":
      return <span>Refund&nbsp;Initiated</span>;
    case "Refund_failed":
      return <span>Refund&nbsp;Failed</span>;
    case "Not found in ap":
      return <span>NOT FOUND IN AP</span>;
    case "Match":
      return <span>MATCH</span>;
    case "Mismatch":
      return <span>MISMATCH</span>;
    default:
      // return <span>{status}</span>;
      return <span>{status}</span>;
  }
};

// export const formatAmount = (amount, decimal, string, removeFloat) => {
//   if (typeof amount === "string" && string) {
//     amount = parseFloat(amount);
//   }

//   if (isNaN(amount)) return decimal ? "0" : "₹0.00";

//   const options = {
//     style: decimal ? "decimal" : "currency",
//     minimumFractionDigits: decimal && !removeFloat ? "2" : undefined,
//     currency: !decimal ? "INR" : undefined,
//   };

//   // if (amount >= 1000000) {
//   //   options.notation = "compact";
//   // }

//   if (decimal) return amount?.toLocaleString("en-IN", options);

//   return amount?.toLocaleString("en-IN", options);
// };

// export const formatAmount = (
//   amount,
//   decimal,
//   removeFloat,
//   compactFormat // lakh, 10lakh, crore
// ) => {
//   let Amt = typeof amount === "string" ? parseFloat(amount) : amount;

//   if (isNaN(Amt || amount)) return decimal ? "0" : "₹0.00";

//   const isCompactAmount = (finalAmount, format) => {
//     const options = {
//       style: decimal ? "decimal" : "currency",
//       minimumFractionDigits: decimal && !removeFloat ? "2" : undefined,
//       currency: !decimal ? "INR" : undefined,
//     };

//     if (format) {
//       let croreCondition =
//         (format === "crore" || "10lakh" || "lakh") && amount >= 10000000;
//       let tenlakhCondition =
//         (format === "10lakh" || "lakh") && amount >= 1000000;
//       let lakhCondition = format === "lakh" && amount >= 100000;

//       if (croreCondition) {
//         // Convert to Crores
//         amount /= 10000000;
//         return decimal
//           ? Math.floor(amount * 100) / 100 + " Cr"
//           : "₹" + Math.floor(amount * 100) / 100 + " Cr";
//       } else if (tenlakhCondition) {
//         // Convert to Lakhs if more than 10 Lakhs
//         amount /= 1000000;
//         return decimal
//           ? Math.floor(amount * 1000) / 100 + " L"
//           : "₹" + Math.floor(amount * 1000) / 100 + " L";
//       } else if (lakhCondition) {
//         // Convert to Lakhs if more than 1 Lakh
//         amount /= 100000;
//         return decimal
//           ? Math.floor(amount * 100) / 100 + " L"
//           : "₹" + Math.floor(amount * 100) / 100 + " L";
//       }
//     }

//     if (decimal) return finalAmount?.toLocaleString("en-IN", options);

//     return finalAmount?.toLocaleString("en-IN", options);
//   };

//   // Two options for more control when to use compact amount
//   if (compactFormat) {
//     return isCompactAmount(Amt, compactFormat);
//   } else {
//     return isCompactAmount(Amt);
//   }
// };

export const formatAmount = (amount, decimal, removeFloat, compactFormat) => {
  let Amt = typeof amount === "string" ? parseFloat(amount) : amount;

  if (isNaN(Amt)) return decimal ? "0" : "₹0.00";

  const formatWithCommas = (amount) => {
    const options = {
      style: decimal ? "decimal" : "currency",
      minimumFractionDigits: decimal && !removeFloat ? 2 : 0,
      maximumFractionDigits: 2,
      currency: !decimal ? "INR" : undefined,
    };
    return amount.toLocaleString("en-IN", options); // Adds commas and currency
  };

  const formatCompactAmount = (amount, format) => {
    const removeTrailingZeroes = (value) => {
      return parseFloat(value).toString();
    };

    // Compact formatting logic for "lakh" and "crore"
    if (format === "lakh" || format === "10lakh" || format === "crore") {
      if (amount >= 10000000) {
        // Convert to Crore
        amount /= 10000000;
        return decimal
          ? removeTrailingZeroes(amount.toFixed(2)) + " Cr"
          : "₹" + removeTrailingZeroes(amount.toFixed(2)) + " Cr";
      } else if (amount >= 100000) {
        // Convert to Lakhs
        amount /= 100000;
        // Round the amount to 2 decimal places, ensuring 2 decimal places even if the value is a whole number
        const roundedAmount = amount.toFixed(2); // This ensures 2 decimals like 1.90, 1.00, etc.

        // Display as Lakh with no decimals if it's a whole number (like ₹10 L)
        if (parseFloat(roundedAmount) % 1 === 0) {
          return decimal
            ? roundedAmount.split(".")[0] + " L"
            : "₹" + roundedAmount.split(".")[0] + " L";
        }

        // Otherwise, show 2 decimal places
        return decimal ? roundedAmount + " L" : "₹" + roundedAmount + " L";
      }
    }

    // If no compact formatting is requested, fall back to standard formatting
    return formatWithCommas(amount);
  };

  if (compactFormat) {
    // Apply compact formatting if provided
    return formatCompactAmount(Amt, compactFormat);
  } else {
    // Otherwise, simply return formatted amount with commas
    return formatWithCommas(Amt);
  }
};

export const formatCount = (count) => {
  if (count >= 1000 && count < 1000000) {
    return count / 1000 + "k";
  } else if (count >= 1000000) {
    return count / 1000000 + "M";
  }
  return count.toString();
};

export const checkAccessPermission = (actionType, moduleCode, accessData) => {
  const state = rootReducer.getState();

  const data = accessData ? accessData : state.sidebar;

  // console.log("Access Data:", data); // Log the access data

  if (data) {
    const checkModule = (modules) => {
      for (const module of modules) {
        // console.log("Checking module:", module); // Log the module being checked
        if (module?.action === actionType && module?.code === moduleCode) {
          // console.log(`Match found for action: ${actionType} and moduleCode: ${moduleCode}`);
          if (module?.access_flag === 1) {
            // console.log("Access granted");
            return true;
          } else {
            // console.log("Access denied (flag not 1)");
          }
        }
        if (module?.menus && module?.menus?.length > 0) {
          if (checkModule(module?.menus)) {
            return true;
          }
        }
      }
      return false;
    };

    return checkModule(data);
  }
  // console.log("No data found, returning false.");
  return false;
};

export const checkButtonAccess = (actionType, moduleCode, accessData) => {
  const state = rootReducer.getState();

  // Use accessData from parameters or fall back to sidebarData in the state
  const data = accessData || state.common.sidebarData;

  if (data) {
    const checkModule = (modules) => {
      for (const module of modules) {
        // Check if the current module matches the action type and module code
        if (module?.action === actionType && module?.code === moduleCode) {
          // Check the access flag for granting or denying access
          if (module?.access_flag === 1) {
            return true; // Access granted
          }
        }

        // If there are nested menus, check them recursively
        if (module?.menus && module?.menus?.length > 0) {
          if (checkModule(module.menus)) {
            return true;
          }
        }
      }
      return false;
    };

    return checkModule(data);
  }

  return false; // No data found, access denied
};

// Function to specifically check for "CREATE" access
// export const checkCreateAccess = (moduleCode, accessData) => {
//   return checkButtonAccess("CREATE", moduleCode, accessData);
// };

// Example usage

export const getDropDownList = (data, cat_name) => {
  const arr = new Set();
  data.map((item) => arr.add(item[cat_name]));
  let newArray = Array.from(arr);
  let listarr = newArray.map((item) => ({
    label: item?.charAt(0).toUpperCase() + item?.slice(1).toLowerCase(),
    value: item,
  }));
  return listarr;
};

export const handleFromDateChange = (
  e,
  dateState,
  setDateState,
  reducerName
) => {
  const fromDate = e[0];
  setDateState({ ...dateState, from_date: fromDate });

  const minDateForToDate = fromDate || new Date("01-01-2018");
  const to_date = dateState.to_date;

  if (to_date < minDateForToDate) {
    setDateState({ ...dateState, to_date: minDateForToDate });
  }

  rootReducer.dispatch(
    reducerName({
      name: "from_date",
      value: dateFormat(e[0], "yyyy-mm-dd hh:mm:ss"),
    })
  );
};

export const handleToDateChange = (e, dateState, setDateState, reducerName) => {
  const toDate = e[0];
  const fromDate = dateState.from_date;

  if (fromDate && toDate < fromDate) {
    setDateState({ from_date: toDate, to_date: toDate });
  } else {
    setDateState({ from_date: fromDate, to_date: toDate });
  }

  rootReducer.dispatch(
    reducerName({
      name: "to_date",
      value: dateFormat(e[0], "yyyy-mm-dd hh:mm:ss"),
    })
  );
};

export const calculateElapsedTime = (
  startDate,
  startTime,
  endDate,
  endTime
) => {
  const startDateTime = new Date(`${startDate}T${startTime}`);
  const endDateTime = new Date(`${endDate}T${endTime}`);
  // Calculate the difference in milliseconds
  const timeDifference = endDateTime - startDateTime;
  // Convert milliseconds to seconds
  const elapsedSeconds = isNaN(timeDifference)
    ? 0
    : Math.floor(timeDifference / 1000);
  // Calculate days, hours, minutes, and seconds
  const days = Math.floor(elapsedSeconds / (3600 * 24));
  const hours = Math.floor((elapsedSeconds % (3600 * 24)) / 3600);
  const minutes = Math.floor((elapsedSeconds % 3600) / 60);
  const seconds = elapsedSeconds % 60;
  // Build the elapsed time string dynamically
  let elapsedTimeString = "";
  if (days > 0) {
    elapsedTimeString += `${days}d `;
  }
  if (hours > 0 || days > 0) {
    elapsedTimeString += `${hours}h `;
  }
  if (minutes > 0 || hours > 0 || days > 0) {
    elapsedTimeString += `${minutes}m `;
  }
  elapsedTimeString += `${seconds}s`;

  return elapsedTimeString?.trim();
};

export const getInitials = (name) => {
  const nameParts = name.split(" ");
  return nameParts
    .map((part) => part.charAt(0))
    .join("")
    .toUpperCase();
};

export const convertInvalidDateFormat = (date) => {
  const year = parseInt(date?.substring(0, 4), 10);
  const month = parseInt(date?.substring(4, 6), 10) - 1;
  const day = parseInt(date?.substring(6, 8), 10);

  return new Date(year, month, day);
};

export const apiParams = (
  pageNumber,
  rowsPerPage,
  tabValue,
  statusColumn,
  id
) => {
  let apiParams =
    tabValue === "ALL"
      ? {
          page: pageNumber,
          size: rowsPerPage,
          column: statusColumn,
          parent_id: id,
        }
      : {
          page: pageNumber,
          size: rowsPerPage,
          column: statusColumn,
          parent_id: id,
          value: tabValue,
        };

  return apiParams;
};

// export const filterApiParams = (
//   pageNumber,
//   rowsPerPage,
//   statusColumn,
//   tabValue
// ) => {
//   let filterApiParams =
//     tabValue === "ALL"
//       ? {
//           page: pageNumber,
//           size: rowsPerPage,
//         }
//       : {
//           page: pageNumber,
//           size: rowsPerPage,
//           column: statusColumn,
//           value: tabValue,
//           tab_column: statusColumn,
//           tab_value: tabValue,
//         };

//   return filterApiParams;
// };

export const sortApiParams = (
  serverSorting,
  pageNumber,
  rowsPerPage,
  sortColumn,
  sortOrder,
  statusColumn,
  tabValue,
  listEntityType
) => {
  let sortApiParams =
    serverSorting && tabValue === "ALL"
      ? {
          page: pageNumber,
          size: rowsPerPage,
          sortColumn: sortColumn,
          sortOrder: sortOrder,
          listEntityType: listEntityType,
        }
      : {
          page: pageNumber,
          size: rowsPerPage,
          column: statusColumn,
          value: tabValue,
          sortColumn: sortColumn,
          sortOrder: sortOrder,
          listEntityType: listEntityType,
        };

  return sortApiParams;
};

export const ViewColumnSkeleton = ({ content, classname, id, basic }) => {
  const skeletonLoading = useSelector((state) => state.common.loader.skeleton);

  return skeletonLoading ? (
    <Skeleton classes={"text width-80"} />
  ) : basic ? (
    content
  ) : (
    <div id={id} className={classname ? classname : "viewdata"}>
      {content}
    </div>
  );
};

export const customDebounce = (func, delay) => {
  let timerId;

  return function (...args) {
    const context = this;

    clearTimeout(timerId);
    timerId = setTimeout(() => {
      func.apply(context, args);
    }, delay);
  };
};

export const customThrottle = (func, limit) => {
  let wait = false;

  return function (...args) {
    if (wait) return;

    func(...args);
    wait = true;
    setTimeout(() => {
      console.log("Timeout executed");
      wait = false;
    }, limit);
  };
};
export const handleFlatpickerClose = (dates, reducerName, fromKey, toKey) => {
  const from = fromKey || "from_date";
  const to = toKey || "to_date";
  if (!dates || dates.length === 0) {
    rootReducer.dispatch(
      reducerName({ name: from, value: "" })
    );
    rootReducer.dispatch(
      reducerName({ name: to, value: "" })
    );
    return;
  }
  if (dates.length === 1) {
    rootReducer.dispatch(
      reducerName({ name: from, value: "" })
    );
    rootReducer.dispatch(
      reducerName({ name: to, value: "" })
    );
    return;
  }

  const fromDate = dateFormat(dates[0], "yyyy-mm-dd");
   const toDate = dateFormat(dates[1], "yyyy-mm-dd");
  rootReducer.dispatch(
    reducerName({
      name: from,
      value: fromDate,
    })
  );

  rootReducer.dispatch(
    reducerName({
      name: to,
      value: toDate,
    })
  );
}


export const handleFilterDateChange = (e, reducerName, fromKey, toKey) => {
  if (e.length === 2) {
    
    const fromDate = dateFormat(e[0], "yyyy-mm-dd");
    const toDate = dateFormat(e[1], "yyyy-mm-dd");
    rootReducer.dispatch(
      reducerName({
        name: fromKey ? fromKey : "from_date",
        value: fromDate,
      })
    );
    rootReducer.dispatch(
      reducerName({
        name: toKey ? toKey : "to_date",
        value: toDate,
      })
    );
  }
};

export const handleClearDate = (reducerName, fromKey, toKey) => {
  rootReducer.dispatch(
    reducerName({
      name: fromKey ? fromKey : "from_date",
      value: "",
    })
  );
  rootReducer.dispatch(
    reducerName({
      name: toKey ? toKey : "to_date",
      value: "",
    })
  );
  rootReducer.dispatch(reducerName({ type: "clearDate" }));
};

export const removeEmptyKeysFromState = (formState) => {
  for (const key in formState) {
    if (formState.hasOwnProperty(key) && formState[key] === "") {
      delete formState[key];
    }
  }
};

//   export const commonAccessChecker=(code,action)=>{
//     console.log(code,action);
// const moduleAccessState=rootReducer.getState().moduleaccesstree;
//     const a=  moduleAccessState.menu.find((item)=>item.code==code && item.action==action);

// if(a==undefined){
//   return false;}
// return true;
//   }

export const commonAccessChecker = (code, action, moduleAccessState) => {
  return true;
  // const accessItem = moduleAccessState.menu.find(
  //   (item) => item.code === code && item.action === action
  // );
  // return accessItem !== undefined;
};

export const btnAccessChecker = (code, action, moduleAccessState) => {
  return true;
  // const accessItem = moduleAccessState.menu.find(
  //   (item) => item.code === code && item.action === action
  // );
  // if (accessItem.access_flag == 1) {
  //   return true;
  // } else {
  //   return false;
  // }
};

export const getOrganizationId = () => {
  let orgId = useSelector((state) => state.common.user.orgId);
  if (!orgId) {
    orgId = localStorage.getItem("organizationId");
    if (orgId) {
      rootReducer.dispatch(setOrgId(orgId)); // Set orgId in Redux store
    }
  }

  return orgId;
};

export const getOrganizationType = () => {
  let organizationType = useSelector(
    (state) => state.common.user.organizationType
  );
  if (!organizationType) {
    organizationType = localStorage.getItem("organizationType");
    if (organizationType) {
      rootReducer.dispatch(setOrganizationType(organizationType));
    }
  }

  return organizationType;
};

export const getOrgId = () => {
  const [organizationId, setOrganizationId] = useState(null);
  const dropdownData = useSelector((state) => state.header.dropdownData);
  const selectedUser = useSelector((state) => state.header.selectedUser);

  useEffect(() => {
    const initialOrganizationId = localStorage.getItem("organizationId");
    if (initialOrganizationId) {
      setOrganizationId(initialOrganizationId);
    }
  }, []);

  useEffect(() => {
    const list = dropdownData?.[selectedUser?.providerName];
    if (selectedUser?.name && Array.isArray(list)) {
      const selectedObject = list.find(
        (obj) => obj.name === selectedUser.name
      );
      if (selectedObject) {
        setOrganizationId(selectedObject.organizationid);
      }
    }
  }, [selectedUser?.name, selectedUser?.providerName, dropdownData]);

  return organizationId;
};

export const getOrgType = () => {
  const [organizationType, setOrganizationType] = useState(" ");
  const dropdownData = useSelector((state) => state.header.dropdownData);
  const selectedUser = useSelector((state) => state.header.selectedUser);

  useEffect(() => {
    const initialOrganizationType = localStorage.getItem("organizationType");
    if (initialOrganizationType) {
      setOrganizationType(initialOrganizationType);
    }
  }, []);

  useEffect(() => {
    const list = dropdownData?.[selectedUser?.providerName];
    if (selectedUser?.name && Array.isArray(list)) {
      const selectedObject = list.find(
        (obj) => obj.name === selectedUser.name
      );
      if (selectedObject) {
        setOrganizationType(selectedObject.organization_type);
      }
    }
  }, [selectedUser?.name, selectedUser?.providerName, dropdownData]);

  return organizationType;
};

export const getEntityType = () => {
  const [entityType, setEntityType] = useState("");
  const dropdownData = useSelector((state) => state.header.dropdownData);
  const selectedUser = useSelector((state) => state.header.selectedUser);

  useEffect(() => {
    const initialEntityType = localStorage.getItem("entityType");

    if (initialEntityType) {
      setEntityType(initialEntityType);
    }
  }, []);

  useEffect(() => {
    const list = dropdownData?.[selectedUser?.providerName];
    if (selectedUser?.name && Array.isArray(list)) {
      const selectedObject = list.find(
        (obj) => obj.name === selectedUser.name
      );
      if (selectedObject) {
        setEntityType(selectedObject.entitytype);

        // Optionally, save the selected entityType to localStorage
        localStorage.setItem("entityType", selectedObject.entitytype);
      }
    }
  }, [selectedUser?.name, selectedUser?.providerName, dropdownData]);

  return entityType;
};

export let getEntityId = () => {
  const [entityid, setEntityId] = useState("");
  const dropdownData = useSelector((state) => state.header.dropdownData);
  const selectedUser = useSelector((state) => state.header.selectedUser);

  useEffect(() => {
    // Load initial entityId from localStorage
    const initialEntityId = localStorage.getItem("entityId");

    if (initialEntityId) {
      setEntityId(initialEntityId);
    }
  }, []);

  useEffect(() => {
    const list = dropdownData?.[selectedUser?.providerName];
    if (selectedUser?.name && Array.isArray(list)) {
      const selectedObject = list.find(
        (obj) => obj.name === selectedUser.name
      );
      if (selectedObject) {
        setEntityId(selectedObject.entityid);

        // Save the selected entityId to localStorage
        localStorage.setItem("entityId", selectedObject.entityid);
      }
    }
  }, [selectedUser?.name, selectedUser?.providerName, dropdownData]);

  return entityid;
};

// export const useHierarchyCode = (organizationId) => {
//   const [hierarchyCode, setHierarchyCode] = useState("");
//   const orgMappingData = useSelector((state) => state.organization.selectedOrganization.orgMappingData);

//   useEffect(() => {
//     if (orgMappingData.length > 0) {
//       const foundOrg = orgMappingData.find(org => org.organization_id === organizationId);
//       if (foundOrg) {
//         setHierarchyCode(foundOrg.hierarchy_code);
//       }
//     }
//   }, [organizationId, orgMappingData]);

//   return hierarchyCode;
// };

// export const extractHierarchyCodes = (data) => {
//   return data.map(item => item.hierarchy_code);
// };

export const extractHierarchyCodesById = (data, id) => {
  const item = data.find((item) => item.id === id);
  return item ? item.hierarchy_code : null;
};

export const extractOrganizationId = (node) => {
  if (!node) return null;

  if (node.hierarchy_node && node.hierarchy_node.organization_id) {
    return node.hierarchy_node.organization_id;
  }

  if (node.child_node && node.child_node.length) {
    for (let child of node.child_node) {
      const id = extractOrganizationId(child);
      if (id) return id;
    }
  }

  return null;
};

export const clearExistingToken = () => {
  const existingToken = localStorage.getItem("token");
  const username = localStorage.getItem("username");

  if (existingToken && username) {
    localStorage.removeItem("token"); // Remove the token
    localStorage.removeItem("username");
    localStorage.removeItem("entityid");
    localStorage.removeItem("entityType");
    localStorage.removeItem("organizationId"); // Remove the username
    localStorage.removeItem("organizationType");
    localStorage.removeItem("selectedUser"); // Remove the username
    // Remove the username

    reducer.dispatch(setAuth(false)); // Dispatch action to update auth state
  }
};

export const formateDate = (dateString) => {
  if (!dateString) return "-";
  const [year, month, day] = dateString.split("T")[0].split("-");
  return `${day}-${month}-${year}`;
};

export const filterDateOptions = {
  maxDate: new Date(),
  altInputClass: "hide",
  mode: "range",
  dateFormat: "d M Y",
  minDate: new Date("01-01-2018"),
};

export const withAccessControl = (Component, actionType, moduleCode) => {
  return (props) => {
    const sidebarState = useSelector((state) => state.sidebar);
    const hasPermission = checkAccessPermission(
      actionType,
      moduleCode,
      sidebarState
    );

    return hasPermission ? (
      <Component {...props} />
    ) : (
      <Navigate to="/access-denied" />
    );
  };
};

export const downloadFileFromURL = (url, filename) => {
  fetch(url, {
    responseType: "blob",
  })
    .then((response) => {
      if (!response.ok) {
        console.error(`Error! Response status: ${response.status}`);
      }
      return response.blob();
    })
    .then((blob) => {
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename || "download";
      link.style.display = "none";
      document.body.appendChild(link);
      setTimeout(() => {
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(blobUrl);
      }, 0);
    });
};

export const extractDocumentFiles = (layout) => {
  let documentFiles = [];

  // Recursive function to traverse the layout structure
  const traverseLayout = (elements) => {
    elements.forEach((element) => {
      if (element.elementtype === "documentFile") {
        documentFiles.push(element); // Add element to the result array
      }

      // If the element has child elements, recurse into them
      if (Array.isArray(element.child)) {
        traverseLayout(element.child);
      }
    });
  };

  traverseLayout(layout); // Start traversing the provided layout
  return documentFiles; // Return the array of documentFile elements
};

export const renderOrderStatus = (proposalFilled) => {
  if (proposalFilled === 1) {
    return "Yes";
  } else {
    return "No";
  }
};


export function numberToWords(num) {
  if (num === null || num === undefined || num === "");

  num = num.toString().replace(/,/g, "");
  if (isNaN(num)) return "Invalid number";

  num = Number(num);
  if (num === 0) return;

  const ones = [
    "", "One", "Two", "Three", "Four", "Five",
    "Six", "Seven", "Eight", "Nine", "Ten",
    "Eleven", "Twelve", "Thirteen", "Fourteen",
    "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"
  ];

  const tens = [
    "", "", "Twenty", "Thirty", "Forty",
    "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"
  ];

  const units = [
    { value: 100000000000, name: "Kharab" },
    { value: 1000000000, name: "Arab" },
    { value: 10000000, name: "Crore" },
    { value: 100000, name: "Lakh" },
    { value: 1000, name: "Thousand" },
    { value: 100, name: "Hundred" }
  ];

  function convertBelowHundred(n) {
    if (n < 20) return ones[n];
    return tens[Math.floor(n / 10)] + (n % 10 ? " " + ones[n % 10] : "");
  }

  function convert(n) {
    if (n < 100) return convertBelowHundred(n);

    let result = "";

    for (let unit of units) {
      if (n >= unit.value) {
        let count = Math.floor(n / unit.value);
        result += convert(count) + " " + unit.name + " ";
        n = n % unit.value;
      }
    }

    if (n > 0) {
      result += convertBelowHundred(n) + " ";
    }

    return result.trim();
  }

  return convert(num);
}





